export default class AdminUserSimple {
    adminId: string
    familyName: string
    firstName: string

    constructor(adminId: string, familyName: string, firstName: string) {
        this.adminId = adminId
        this.familyName = familyName
        this.firstName = firstName
    }

    static from(json: any): AdminUserSimple {
        return new AdminUserSimple(
            json.adminId,
            json.familyName,
            json.firstName,
        )
    }
}
